/** полные reducer-ы для всех API вызовов
 * собираются из типовых вызовов метода `reducer()` соответствующих объектов
 */
// import auth, { middleware as authMiddleware } from "./auth";

import session from "./session";
import api from "./api";
import auth from "./auth";
import env from "./env";

const modulesToReducers = (modules) => {
  const reducers = {};
  const middlewares = [];
  for (let ident in modules) {
    Object.assign(reducers, { [ident]: modules[ident].reducer() });
    middlewares.push(modules[ident].middleware());
  }
  return { reducers, middlewares };
};

const actions = { session, auth, api, env };
export default { actions, ...modulesToReducers(actions) };
